<div class="container-fluid pagenofound">
<div class="row animated fadeIn fast">
  <div class="container col-12">
  <img class="img-fluid py-5 animated fadeIn slow" src="../../assets/img/404.svg" alt="Pagina 404, page no found">

  <h1> 404 </h1>
  <h3> Pagina no encontrada </h3>
  <p>Para regresar al inicio, aqui abajo hay un boton.</p>
  <a routerLink="/home" class="btn btn-back"> Regresar </a>
  </div>


</div>
</div>
